import React from "react";

import { useState, useRef } from "react";
import { Box, Image, Text } from "@chakra-ui/react";

export default function UploadBtn({
  acceptImageType,
  demoIcon,
  demoText,
  demoText2,
}) {
  const [image, setImage] = useState(null);
  const fileInputRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];

    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  return (
    <Box
      cursor="pointer"
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onClick={handleClick}
    >
      <input
        type="file"
        accept={acceptImageType}
        onChange={handleFileInputChange}
        ref={fileInputRef}
        style={{ display: "none" }}
      />
      {image ? (
        <Image
          src={image}
          alt="Uploaded Image"
          sx={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      ) : (
        <Text color="#c5c5c5">Logo +JPG and PNG File</Text>
      )}
    </Box>
  );
}
